import { z } from 'zod';
// Сервер отдаёт для страницы /invite/:token (без авторизации)
export const InvitePreviewResponseSchema = z.object({
    studentFullName: z.string(),
    tutorName: z.string(),
    expired: z.boolean(),
    consumed: z.boolean(),
});
// Тело запроса на принятие инвайта — пароль, который ученик задаёт при первом входе
export const InviteAcceptRequestSchema = z.object({
    password: z.string().min(8).max(200),
});
// Ответ при создании инвайта репетитором (видит раз, сам пересылает)
export const CreateInviteResponseSchema = z.object({
    url: z.string(),
    expiresAt: z.string(),
});
//# sourceMappingURL=invites.js.map